import { useAuth } from '@/hooks/useAuth';
import { AppTopHeader } from '@/components/AppTopHeader';
import { UserSettingsForm } from '@/components/UserSettingsForm';

export default function SettingsPage() {
  const { user, updateUser } = useAuth();

  return (
    <div className="min-h-screen bg-[#f6f4ef]">
      <div className="hidden md:block">
        <AppTopHeader />
      </div>
      <main className="mx-auto flex w-full max-w-[640px] flex-col gap-6 px-4 pb-[calc(5.5rem+env(safe-area-inset-bottom))] pt-6 font-[family-name:var(--font-meaning-sans)] sm:px-6 md:pb-12 md:pt-12">
        <header>
          <h1 className="font-[family-name:var(--font-display)] text-[1.9rem] font-semibold leading-[1.15] tracking-[-0.01em] text-[#1e1c18]">
            Settings
          </h1>
          <p className="mt-2 text-sm leading-[1.55] text-[#6b6659]">
            Your languages and how saved phrases are shown. Nothing changes until you save.
          </p>
        </header>

        <section
          aria-label="Preferences"
          className="rounded-2xl border border-[#ece9e2] bg-white p-5 sm:p-6"
        >
          {/* Keyed on the account, not on its values: the form seeds its fields once the user has
              loaded, and must not be thrown away and remounted every time a save comes back. */}
          <UserSettingsForm
            key={user?.id ?? 'loading'}
            initialNativeLanguage={user?.nativeLanguage}
            initialLearningLanguage={user?.learningLanguage}
            initialUseSlottedForm={user?.useSlottedForm ?? false}
            submitLabel="Save changes"
            successMessage="Your preferences have been saved."
            onSaved={updateUser}
          />
        </section>
      </main>
    </div>
  );
}
